import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // @ts-check


import * as React from 'react';
/**
 * @typedef {object} State
 * @prop {number} index
 * @prop {({ key: string } & (State | {}))[]} routes
 * @prop {boolean} [isTransitioning]
 *
 * @typedef {object} ParentPayload
 * @prop {string} type
 * @prop {object} action
 * @prop {State} state
 * @prop {State | {key: string, routes?: undefined, index?: undefined, isTransitioning?: undefined} | undefined | null} lastState
 * @prop {string} [context]
 *
 * @typedef {object} Payload
 * @prop {string} type
 * @prop {object} action
 * @prop {State | {key: string}} state
 * @prop {State | {key: string} | undefined | null} lastState
 * @prop {string} [context]
 *
 * @typedef {object} Props
 * @prop {object} navigation
 * @prop {Function} navigation.addListener
 * @prop {Function} navigation.removeListener
 * @prop {() => boolean} navigation.isFocused
 * @prop {() => object | undefined} navigation.dangerouslyGetParent
 * @prop {State} navigation.state
 * @prop {(target: string, type: string, data: any) => void} onEvent
 *
 * @extends {React.Component<Props>}
 */

var NavigationEventManager = /*#__PURE__*/function (_React$Component) {
  _inherits(NavigationEventManager, _React$Component);

  var _super = _createSuper(NavigationEventManager);

  function NavigationEventManager() {
    var _this;

    _classCallCheck(this, NavigationEventManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_actionSubscription", void 0);

    _defineProperty(_assertThisInitialized(_this), "_willFocusSubscription", void 0);

    _defineProperty(_assertThisInitialized(_this), "_willBlurSubscription", void 0);

    _defineProperty(_assertThisInitialized(_this), "_didFocusSubscription", void 0);

    _defineProperty(_assertThisInitialized(_this), "_didBlurSubscription", void 0);

    _defineProperty(_assertThisInitialized(_this), "_refocusSubscription", void 0);

    _defineProperty(_assertThisInitialized(_this), "_lastWillBlurKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "_lastWillFocusKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "_lastDidBlurKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "_lastDidFocusKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "_handleAction", function (_ref) {
      var state = _ref.state,
          lastState = _ref.lastState,
          action = _ref.action,
          type = _ref.type,
          context = _ref.context;

      var _lastState$routes;

      var _this$props = _this.props,
          navigation = _this$props.navigation,
          onEvent = _this$props.onEvent; // We should only emit events when the navigator is focused
      // When navigator is not focused, screens inside shouldn't receive focused status either

      if (!navigation.isFocused()) {
        return;
      }

      var previous = lastState ? (_lastState$routes = lastState.routes) === null || _lastState$routes === void 0 ? void 0 : _lastState$routes[lastState.index] : undefined;
      var current = state.routes[state.index];
      var payload = {
        context: "".concat(current.key, ":").concat(action.type, "_").concat(context || 'Root'),
        state: current,
        lastState: previous,
        action: action,
        type: type
      };

      if ((previous === null || previous === void 0 ? void 0 : previous.key) !== current.key) {
        _this._emitWillFocus(current.key, payload);

        if (previous === null || previous === void 0 ? void 0 : previous.key) {
          _this._emitWillBlur(previous.key, payload);
        }
      }

      if ((lastState === null || lastState === void 0 ? void 0 : lastState.isTransitioning) !== state.isTransitioning && state.isTransitioning === false) {
        if (_this._lastWillBlurKey) {
          _this._emitDidBlur(_this._lastWillBlurKey, payload);
        }

        if (_this._lastWillFocusKey) {
          _this._emitDidFocus(_this._lastWillFocusKey, payload);
        }
      }

      onEvent(current.key, 'action', payload);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleWillFocus", function (_ref2) {
      var lastState = _ref2.lastState,
          action = _ref2.action,
          context = _ref2.context,
          type = _ref2.type;

      var _lastState$routes2;

      var navigation = _this.props.navigation;
      var route = navigation.state.routes[navigation.state.index];

      _this._emitWillFocus(route.key, {
        context: "".concat(route.key, ":").concat(action.type, "_").concat(context || 'Root'),
        state: route,
        lastState: lastState === null || lastState === void 0 ? void 0 : (_lastState$routes2 = lastState.routes) === null || _lastState$routes2 === void 0 ? void 0 : _lastState$routes2.find(function (r) {
          return r.key === route.key;
        }),
        action: action,
        type: type
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleWillBlur", function (_ref3) {
      var lastState = _ref3.lastState,
          action = _ref3.action,
          context = _ref3.context,
          type = _ref3.type;

      var _lastState$routes3;

      var navigation = _this.props.navigation;
      var route = navigation.state.routes[navigation.state.index];

      _this._emitWillBlur(route.key, {
        context: "".concat(route.key, ":").concat(action.type, "_").concat(context || 'Root'),
        state: route,
        lastState: lastState === null || lastState === void 0 ? void 0 : (_lastState$routes3 = lastState.routes) === null || _lastState$routes3 === void 0 ? void 0 : _lastState$routes3.find(function (r) {
          return r.key === route.key;
        }),
        action: action,
        type: type
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleDidFocus", function (_ref4) {
      var lastState = _ref4.lastState,
          action = _ref4.action,
          context = _ref4.context,
          type = _ref4.type;
      var navigation = _this.props.navigation;

      if (_this._lastWillFocusKey) {
        var route = navigation.state.routes.find(function (r) {
          return r.key === _this._lastWillFocusKey;
        });

        if (route) {
          var _lastState$routes4;

          _this._emitDidFocus(route.key, {
            context: "".concat(route.key, ":").concat(action.type, "_").concat(context || 'Root'),
            state: route,
            lastState: lastState === null || lastState === void 0 ? void 0 : (_lastState$routes4 = lastState.routes) === null || _lastState$routes4 === void 0 ? void 0 : _lastState$routes4.find(function (r) {
              return r.key === route.key;
            }),
            action: action,
            type: type
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleDidBlur", function (_ref5) {
      var lastState = _ref5.lastState,
          action = _ref5.action,
          context = _ref5.context,
          type = _ref5.type;
      var navigation = _this.props.navigation;

      if (_this._lastWillBlurKey) {
        var route = navigation.state.routes.find(function (r) {
          return r.key === _this._lastWillBlurKey;
        });

        if (route) {
          var _lastState$routes5;

          _this._emitDidBlur(route.key, {
            context: "".concat(route.key, ":").concat(action.type, "_").concat(context || 'Root'),
            state: route,
            lastState: lastState === null || lastState === void 0 ? void 0 : (_lastState$routes5 = lastState.routes) === null || _lastState$routes5 === void 0 ? void 0 : _lastState$routes5.find(function (r) {
              return r.key === route.key;
            }),
            action: action,
            type: type
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleRefocus", function () {
      var _this$props2 = _this.props,
          onEvent = _this$props2.onEvent,
          navigation = _this$props2.navigation;
      var route = navigation.state.routes[navigation.state.index];
      onEvent(route.key, 'refocus');
    });

    _defineProperty(_assertThisInitialized(_this), "_emitWillFocus", function (target, payload) {
      if (_this._lastWillBlurKey === target) {
        _this._lastWillBlurKey = undefined;
      }

      if (_this._lastWillFocusKey === target) {
        return;
      }

      _this._lastDidFocusKey = undefined;
      _this._lastWillFocusKey = target;
      var _this$props3 = _this.props,
          navigation = _this$props3.navigation,
          onEvent = _this$props3.onEvent;
      onEvent(target, 'willFocus', payload);

      if (typeof navigation.state.isTransitioning !== 'boolean' || navigation.state.isTransitioning !== true && !navigation.dangerouslyGetParent()) {
        _this._emitDidFocus(target, payload);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_emitWillBlur", function (target, payload) {
      if (_this._lastWillFocusKey === target) {
        _this._lastWillFocusKey = undefined;
      }

      if (_this._lastWillBlurKey === target) {
        return;
      }

      _this._lastDidBlurKey = undefined;
      _this._lastWillBlurKey = target;
      var _this$props4 = _this.props,
          navigation = _this$props4.navigation,
          onEvent = _this$props4.onEvent;
      onEvent(target, 'willBlur', payload);

      if (typeof navigation.state.isTransitioning !== 'boolean' || navigation.state.isTransitioning !== true && !navigation.dangerouslyGetParent()) {
        _this._emitDidBlur(target, payload);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_emitDidFocus", function (target, payload) {
      if (_this._lastWillFocusKey !== target || _this._lastDidFocusKey === target) {
        return;
      }

      _this._lastDidFocusKey = target;
      var onEvent = _this.props.onEvent;
      onEvent(target, 'didFocus', payload);
    });

    _defineProperty(_assertThisInitialized(_this), "_emitDidBlur", function (target, payload) {
      if (_this._lastWillBlurKey !== target || _this._lastDidBlurKey === target) {
        return;
      }

      _this._lastDidBlurKey = target;
      var onEvent = _this.props.onEvent;
      onEvent(target, 'didBlur', payload);
    });

    return _this;
  }

  _createClass(NavigationEventManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var navigation = this.props.navigation;
      this._actionSubscription = navigation.addListener('action', this._handleAction);
      this._willFocusSubscription = navigation.addListener('willFocus', this._handleWillFocus);
      this._willBlurSubscription = navigation.addListener('willBlur', this._handleWillBlur);
      this._didFocusSubscription = navigation.addListener('didFocus', this._handleDidFocus);
      this._didBlurSubscription = navigation.addListener('didBlur', this._handleDidBlur);
      this._refocusSubscription = navigation.addListener('refocus', this._handleRefocus);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$_actionSubscrip, _this$_willFocusSubsc, _this$_willBlurSubscr, _this$_didFocusSubscr, _this$_didBlurSubscri, _this$_refocusSubscri;

      (_this$_actionSubscrip = this._actionSubscription) === null || _this$_actionSubscrip === void 0 ? void 0 : _this$_actionSubscrip.remove();
      (_this$_willFocusSubsc = this._willFocusSubscription) === null || _this$_willFocusSubsc === void 0 ? void 0 : _this$_willFocusSubsc.remove();
      (_this$_willBlurSubscr = this._willBlurSubscription) === null || _this$_willBlurSubscr === void 0 ? void 0 : _this$_willBlurSubscr.remove();
      (_this$_didFocusSubscr = this._didFocusSubscription) === null || _this$_didFocusSubscr === void 0 ? void 0 : _this$_didFocusSubscr.remove();
      (_this$_didBlurSubscri = this._didBlurSubscription) === null || _this$_didBlurSubscri === void 0 ? void 0 : _this$_didBlurSubscri.remove();
      (_this$_refocusSubscri = this._refocusSubscription) === null || _this$_refocusSubscri === void 0 ? void 0 : _this$_refocusSubscri.remove();
    }
    /**
     * @type {{ remove(): void } | undefined}
     */

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return NavigationEventManager;
}(React.Component);

export { NavigationEventManager as default };